/* eslint-disable no-await-in-loop */
import { isEqual } from 'lodash-es';
import sleep from './sleep';

async function waitTillNotEqual(currentObj, getNewObjFn, waitTime = 2000) {
  let isObjectsEqual = true;

  do {
    await sleep(waitTime);
    const newObj = await getNewObjFn();

    isObjectsEqual = isEqual(currentObj, newObj);
  } while (isObjectsEqual);
}

export default waitTillNotEqual;
